import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

const PathologyDashboardSkeleton: React.FC = () => (
    <div className="flex flex-col gap-5 animate-fade-in-up">
        {/* ══ SECTION 1: 4 KPI cards skeleton ══ */}
        <div
            className="grid gap-3"
            style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}
        >
            {[0, 1, 2, 3].map(i => (
                <div
                    key={i}
                    className="relative overflow-hidden rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] p-5 flex flex-col gap-3 shadow-card"
                >
                    <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-[var(--v2-border-card)] rounded-r" />
                    <div className="flex items-center justify-between">
                        <ShimmerBox className="h-3.5 w-24 rounded" delay={`${i * 0.05}s`} />
                        <ShimmerBox className="h-7 w-7 rounded-lg flex-shrink-0" delay={`${i * 0.05 + 0.02}s`} />
                    </div>
                    <ShimmerBox className="h-7 w-12 rounded-md" delay={`${i * 0.05 + 0.04}s`} />
                    <ShimmerBox className="h-3 w-36 rounded" delay={`${i * 0.05 + 0.06}s`} />
                </div>
            ))}
        </div>

        {/* ══ SECTION 2: Import Pipeline card skeleton ══ */}
        <div className="rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] p-5 shadow-card">
            <div className="flex items-center justify-between mb-4">
                <div className="flex flex-col gap-1.5">
                    <ShimmerBox className="h-4 w-28 rounded" delay="0.2s" />
                    <ShimmerBox className="h-3 w-48 rounded" delay="0.22s" />
                </div>
                <div className="flex flex-col items-end gap-1.5 flex-shrink-0">
                    <ShimmerBox className="h-3 w-20 rounded" delay="0.24s" />
                    <ShimmerBox className="w-28 h-1.5 rounded-full" delay="0.26s" />
                </div>
            </div>

            <div className="flex items-stretch gap-0">
                {[0, 1, 2, 3].map((i) => (
                    <React.Fragment key={i}>
                        <div
                            className="flex-1 rounded-xl p-3.5 flex flex-col gap-1.5 min-w-0 bg-[var(--v2-bg-surface)]"
                        >
                            <ShimmerBox className="h-6 w-10 rounded-md" delay={`${i * 0.05 + 0.3}s`} />
                            <ShimmerBox className="h-3 w-16 rounded" delay={`${i * 0.05 + 0.32}s`} />
                            <div className="h-1 rounded-full mt-1 bg-white/60 overflow-hidden">
                                <ShimmerBox className="h-full w-1/2 rounded-full" delay={`${i * 0.05 + 0.34}s`} />
                            </div>
                        </div>
                        {i < 3 && (
                            <div className="flex items-center px-1 flex-shrink-0">
                                <div className="w-3.5 h-3.5" />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>

        {/* ══ SECTION 3: Charts grid skeleton ══ */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {[0, 1].map(i => (
                <div
                    key={i}
                    className="rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] p-5 shadow-card"
                >
                    <div className="flex flex-col gap-1.5 mb-4">
                        <ShimmerBox className="h-4 w-32 rounded" delay={`${i * 0.05 + 0.5}s`} />
                        <ShimmerBox className="h-3 w-56 rounded" delay={`${i * 0.05 + 0.52}s`} />
                    </div>
                    <ShimmerBox className="h-52 w-full rounded-xl" delay={`${i * 0.05 + 0.54}s`} />
                </div>
            ))}
        </div>
    </div>
);

export default PathologyDashboardSkeleton;
